import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

// import MillieApi              from 'app/apis/millie';
import AddressInput           from 'app/components/common/address-input';
import Checkbox               from 'app/components/common/checkbox';
import CityInput              from 'app/components/common/city-input';
import ConnectorLine          from 'app/components/common/connector-line';
import CurrencyInput          from 'app/components/common/currency-input';
import DatePicker             from 'app/components/common/date-picker';
import DateRangePicker        from 'app/components/common/date-range-picker';
import DebugClicker           from 'app/components/common/debug-clicker';
import EllipsisMenu           from 'app/components/common/ellipsis-menu';
import EmojiPicker            from 'app/components/common/emoji-picker';
import Icon                   from 'app/components/common/icon';
import Link                   from 'app/components/common/link';
import LocationInput          from 'app/components/common/location-input';
import NonprofitInput         from 'app/components/common/nonprofit-input';
import NteePicker             from 'app/components/common/ntee-picker';
import Pagination             from 'app/components/common/pagination';
import PhoneInput             from 'app/components/common/phone-input';
import Popper                 from 'app/components/common/popper';
import RadioButton            from 'app/components/common/radio-button';
import RecentDonors           from 'app/components/common/recent-donors';
import RteDebug               from 'app/components/common/rich-text/debug';
import SparkleTriangle        from 'app/components/common/sparkle-triangle';
import StandardInput          from 'app/components/common/standard-input';
import StandardSelect         from 'app/components/common/standard-select';
import TimePicker             from 'app/components/common/time-picker';
import TimezoneInput          from 'app/components/common/timezone-input';
import Text                   from 'app/components/common/text';
import UploadedImageInput     from 'app/components/common/uploaded-image-input';
import MainLayout             from 'app/components/layout/main-layout';
import Bracket                from 'app/components/madness/bracket';
import confetti               from 'app/confetti';
import cdn                    from 'app/helpers/cdn';

const foo = () => {
  bar();
};

const emojiFontOpts = [
  {label: 'Default', value: 'default'},
  {label: 'Apple', value: 'apple'},
  {label: 'Google', value: 'google'},
  {label: 'Microsoft', value: 'microsoft'},
];

class PageStyleGuide extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      startDateStr: null,
      endDateStr: null,
      address: null,
      timezone: null,
      timeStr: null,
      dateStr: null,
      balanceType: null,
      emojiFont: 'default',
    };

    this.onSelectDateRange = this.onSelectDateRange.bind(this);
    this.onClickThrow = this.onClickThrow.bind(this);
    this.onClickConfetti = this.onClickConfetti.bind(this);
    this.onClickConfetti2 = this.onClickConfetti2.bind(this);
    this.onClickConfetti3 = this.onClickConfetti3.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
  }

  onClickConfetti() {
    confetti.fireworks();
  }
  onClickConfetti2() {
    confetti.fireworks2();
  }
  onClickConfetti3(event) {
    confetti.highlight(event.target);
  }

  onClickThrow() {
    foo();
  }

  onSelectDateRange({startDateStr, endDateStr}) {
    this.setState({startDateStr, endDateStr});
  }

  onChangeAddress(address) {
    console.log('onChangeAddress', address);
    this.setState({address});
  }

  onChangeTimezone(timezone) {
    this.setState({timezone});
  }

  onChangeDate(dateStr) {
    this.setState({dateStr});
  }

  onChangeBalanceType(balanceType) {
    this.setState({balanceType});
  }

  renderColors() {
    const colorsGroups = [
      ['Blue', 'Pink', 'Green', 'Purple', 'Yellow', 'Orange', 'Danger'],
      ['Midnight', 'Slate', 'Fog', 'Cloud', 'Ice', 'White'],
      ['Rainbow', 'Sunrise', 'Jungle'],
      ['Gradient Purple', 'Gradient Orange', 'Gradient Pink', 'Gradient Blue', 'Gradient Green'],
    ];
    return (<>
      <h2>Colors</h2>
      {colorsGroups.map((colorGroup, i) => (
        <div key={i} className="color-row">
          {colorGroup.map((color, j) => (
            <div key={j} className="color">
              <div className={`color-circle ${color.toLowerCase().replace(' ', '-')}`} />
              <div className="color-name">{color}</div>
            </div>
          ))}
        </div>
      ))}
    </>);
  }

  onChangeTime(timeStr) {
    this.setState({timeStr});
  }

  onChangePhone(selectedPhone) {
    this.setState({selectedPhone});
  }

  renderButtons() {
    return (<>
      <h2>Buttons</h2>
      <div className="button-cols">
        <div className="button-row">
          <button className="btn midnight">Button</button>
          <button className="btn pink">Button</button>
          <button className="btn blue">Button</button>
          <button className="btn green">Button</button>
          <button className="btn danger">Button</button>
          <button className="btn slate">Button</button>
          <button className="btn icon"><Icon.EnvelopePigeon />Button</button>
        </div>
        <div className="button-row">
          <button className="btn secondary midnight">Button</button>
          <button className="btn secondary pink">Button</button>
          <button className="btn secondary blue">Button</button>
          <button className="btn secondary green">Button</button>
          <button className="btn secondary danger">Button</button>
          <button className="btn secondary slate">Button</button>
          <button className="btn secondary icon"><Icon.EnvelopePigeon />Button</button>
        </div>
        <div className="button-row">
          <button className="btn special sunrise">Button</button>
          <button className="btn special jungle">Button</button>
          <button className="btn special slack">Slack Button</button>
          <button className="btn special jungle icon"><Icon.EnvelopePigeon />Button</button>
        </div>
        <div className="button-row">
          <button className="btn primary pink small">Button</button>
          <button className="btn secondary blue small">Button</button>
          <button className="btn special jungle small">Button</button>
          <button className="btn primary small icon"><Icon.EnvelopePigeon />Button</button>
        </div>
        <div className="button-row">
          <button className="btn special pill orange icon secondary"><Icon.EnvelopePigeon /> Button</button>
          <button className="btn special pill orange icon"><Icon.EnvelopePigeon /> Button</button>
          <button className="btn special pill purple icon secondary"><Icon.EnvelopePigeon /> Button</button>
          <button className="btn special pill purple icon"><Icon.EnvelopePigeon /> Button</button>
        </div>
        <div className="button-row">
          <button disabled className="btn secondary blue">Button</button>
          <button disabled className="btn green">Button</button>
          <button disabled className="btn special jungle small">Button</button>
          <button disabled className="btn special pill orange icon secondary"><Icon.EnvelopePigeon /> Button</button>
        </div>
      </div>
    </>);
  }

  renderIcons() {
    return (<>
      <h2>Icons</h2>
      <div className="icons">
        {_.map(Icon, (IconComp, name) => (
          <div className="icon-group" key={name}>
            <IconComp />
            <span>{name}</span>
          </div>
        ))}
      </div>
    </>);
  }

  render() {
    return (
      <MainLayout dnd>
        <div className="style-guide widther">
          <h1>Style Guide</h1>
          {this.renderColors()}

          {this.renderButtons()}
          {this.renderIcons()}

          <h2>Confetti</h2>
          <button className="btn" onClick={this.onClickConfetti}>Fireworks 1</button>
          &nbsp;
          <button className="btn" onClick={this.onClickConfetti2}>Fireworks 2</button>
          &nbsp;
          <button className="btn" onClick={this.onClickConfetti3}>Highlight</button>

          <h2>Standard Input</h2>
          <StandardInput type="text" name="firstName" label="First name" icon={<Icon.EnvelopePigeon />} />
          <StandardInput type="text" name="firstName" label="First name" value="Bad input" icon={<Icon.EnvelopePigeon />} validations={{firstName: ['invalid input']}} />

          <h2>Standard Select</h2>
          <StandardSelect
            options={[{label: 'Space Cats', value: 1}, {label: 'Shaved Alpacas', value: 2}]}
            value={this.state.standardSelectValue}
            onSelect={(v) => this.setState({standardSelectValue: v})}
          />

          <h2>Date Range Picker</h2>
          <DateRangePicker className="no-trailing nodir" startDateStr={this.state.startDateStr} endDateStr={this.state.endDateStr} onSelect={this.onSelectDateRange} leftAlign />
          <br /><br />
          <DateRangePicker className="no-trailing nodir" startDateStr={this.state.startDateStr} endDateStr={this.state.endDateStr} onSelect={this.onSelectDateRange} leftAlign name="foo" validations={{foo: ['invalid date range']}} />

          <h2>Pagination</h2>
          <Pagination
            pagination={{pageCount: 42, page: 3, resultCount: 411, pageSize: 10}}
            onSelectPage={(page) => { console.log('selected page', page) }}
          />

          <h2>Address Input</h2>
          <AddressInput onChange={this.onChangeAddress.bind(this)} address={this.state.address} />
          <AddressInput onChange={this.onChangeAddress.bind(this)} address={this.state.address} name="foo" validations={{foo: ['invalid address']}} />

          <h2>Timezone Input</h2>
          <TimezoneInput onChange={this.onChangeTimezone.bind(this)} timezone={this.state.timezone} />
          <br /><br />
          <TimezoneInput onChange={this.onChangeTimezone.bind(this)} timezone={this.state.timezone} name="foo" validations={{foo: ['invalid timezone']}} />

          <h2>Time Picker</h2>
          <TimePicker ddAlign="left" timeStr={this.state.timeStr} onChange={this.onChangeTime.bind(this)} />
          <br /><br />
          <TimePicker ddAlign="left" timeStr={this.state.timeStr} onChange={this.onChangeTime.bind(this)} name="foo" validations={{foo: ['invalid time']}} />

          <h2>Date Picker</h2>
          <DatePicker ddAlign="left" onChange={this.onChangeDate.bind(this)} dateStr={this.state.dateStr} />
          <br /><br />
          <DatePicker ddAlign="left" onChange={this.onChangeDate.bind(this)} dateStr={this.state.dateStr} name="foo" validations={{foo: ['invalid date']}} />

          <h2>Radio Buttons</h2>
          <div className="style-guide-radios">
            <RadioButton name="rb-thing" id="rb-gadget" />
            <label htmlFor="rb-gadget">Gadget</label>
            <RadioButton name="rb-thing" id="rb-gizmo" />
            <label htmlFor="rb-gizmo">Gizmo</label>
            <RadioButton name="rb-thing" id="rb-whoozit" />
            <label htmlFor="rb-whoozit">Whoozit</label>
          </div>

          <h2>Checkboxes</h2>
          <div className="style-guide-radios">
            <Checkbox id="cb-demo-plain" />
            <label htmlFor="cb-demo-plain">Default</label>
            <Checkbox id="cb-demo-toggle" isToggle />
            <label htmlFor="cb-demo-toggle">Toggle</label>
          </div>

          <h2>Throw an Error</h2>
          <button className="btn danger" onClick={this.onClickThrow}>Throw an Error</button>

          <h2>Recent Donors</h2>
          <RecentDonors donorCount={0} recentDonors={[]} />
          <RecentDonors donorCount={1} recentDonors={[]} />
          <RecentDonors donorCount={5} recentDonors={[]} />
          <RecentDonors donorCount={3} recentDonors={[{firstName: 'Marvin', id: 'a'}, {firstName: 'Tyler', id: 'b'}, {firstName: 'Rachel', id: 'c'}]} />
          <RecentDonors donorCount={3} recentDonors={[{firstName: 'Rachel', id: 'c'}]} />

          <h2>Sparkle Triangle</h2>
          <div className="triangles-con">
            <SparkleTriangle orientation={1} scale={2} color="blue" />
            <SparkleTriangle orientation={2} scale={2} color="purple" />
            <SparkleTriangle orientation={3} scale={1} color="cyan" />
            <SparkleTriangle orientation={4} scale={2} color="green" />
          </div>
          <div className="triangles-con">
            <SparkleTriangle orientation={2} scale={3} color="orange" />
            <SparkleTriangle orientation={3} scale={1} color="pink" />
            <SparkleTriangle orientation={4} scale={1} color="orange" />
            <SparkleTriangle orientation={1} scale={2} color="slack" />
          </div>

          <h2>Connector Line</h2>
          <div style={{width: 300}}>
            <ConnectorLine />
            <br />
            <ConnectorLine error />
            <br />
            <ConnectorLine success />
          </div>

          <h2>Bracket</h2>
          <select onChange={(e) => {this.setState({bracketSize: parseInt(e.target.value)})}} defaultValue={16}>
            <option value={2}>2</option>
            <option value={4}>4</option>
            <option value={8}>8</option>
            <option value={16}>16</option>
            <option value={32}>32</option>
            <option value={64}>64</option>
          </select>
          <Bracket bracket={{name: 'Bracket Name', size: (this.state.bracketSize || 16)}} />

          <h2>City Input</h2>
          <CityInput onChange={(selectedCity) => {this.setState({selectedCity})}} selectedCity={this.state.selectedCity} />
          {this.state.selectedCity && (<>
            <a href={`https://www.google.com/maps/@${this.state.selectedCity.latitude},${this.state.selectedCity.longitude},12z`} target="blank">Open in gmaps: {this.state.selectedCity.label}</a>
          </>)}
          <LocationInput onChange={(selectedLocation) => this.setState({selectedLocation})} location={this.state.selectedLocation} />

          <h2>Popper</h2>
          <Popper tagType="button" className="btn" hoverTrigger hoverDelay={500} popContent="asdf" popType="tooltip">
            Delayed Hover Tooltip
          </Popper>
          &nbsp;
          <Popper tagType="button" className="btn" focusTrigger popContent="asdf" popType="popover" placement="left">
            Focus Popover Left
          </Popper>

          <h2>Ellipsis Menu</h2>
          <EllipsisMenu>
            <Link href="/wallet"><Icon.AccountingBill />Link to Wallet</Link>
            <Link onClick={(event) => {event.preventDefault(); console.log('------ item onClick')}}><Icon.Megaphone1 />Log to console</Link>
          </EllipsisMenu>
          <EllipsisMenu>
            <Link href="/wallet"><Icon.AccountingBill />Link to Wallet</Link>
            <Link onClick={(event) => {event.preventDefault(); console.log('------ item onClick')}}><Icon.Megaphone1 />Log to console</Link>
          </EllipsisMenu>

          <h2>DebugClicker</h2>
          <DebugClicker id="A" />
          <DebugClicker id="B" />
          <DebugClicker id="C" />

          <h2>NTEE Picker</h2>
          <NteePicker nteeCode={this.state.ntee} onChange={(ntee) => this.setState({ntee})} />

          <h2>Currency Input</h2>
          <CurrencyInput amount={this.state.ciVal?.amount} currencyCode="JPY" onChange={(ciVal) => this.setState({ciVal})} />
          <pre>{JSON.stringify(this.state.ciVal || {}, null, 4)}</pre>

          <h2>Nonprofit Selector</h2>
          <div style={{width: 300}}>
            <NonprofitInput selectedNonprofit={this.state.selectedNp} onChange={(selectedNp) => this.setState({selectedNp})} intl advanced />
          </div>

          <h2>Phone Input</h2>
          <PhoneInput onChange={this.onChangePhone} phone={this.state.selectedPhone} />

          <h2>Uploaded Image Input</h2>
          <UploadedImageInput onChange={(imgPath) => {this.setState({imgPath})}} pathValue={this.state.imgPath} />
          {this.state.imgPath && (
            <img src={cdn.imgUrl(this.state.imgPath, {width: 400})} width={200} />
          )}

          <h2>Render Paragraphs, Linkified</h2>
          <h4>Input</h4>
          <StandardInput onChange={e => this.setState({linkifyStr: e.target.value})} value={this.state.linkifyStr} type="textarea" name="linkifyStr" label="Type some text to see URLs turn into links..." />
          <h4>Output 2</h4>
          <Text.Paragraphs str={this.state.linkifyStr} linkify />

          <h2>Emoji Picker</h2>
          <StandardSelect options={emojiFontOpts} value={this.state.emojiFont} onSelect={(emojiFont) => {this.setState({emojiFont})}} />
          <br /><br />
          <div style={{border: '1px solid #EEE', display: 'inline-block'}}>
            <EmojiPicker className="foo" emojiClassName={this.state.emojiFont} />
          </div>

          <h2>Rich Text</h2>
          <RteDebug />


          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </MainLayout>
    );
  }

}

const stateToProps = (state) => {

};

export default connect()(PageStyleGuide);

